import React, { Component } from 'react';
import PropTypes from 'prop-types';

import noTransactionsImage from '../images/no-transactions.png';
import '../styles/payment-history-no-transactions.css';

class PaymentHistoryNoTransactions extends Component {
  render() {
    const { t } = this.context;
    const { status } = this.props;

    return (
      <div className="no-transactions-container">
        <div className="no-transactions-container__wrapper">
          <img src={noTransactionsImage} alt="No Transactions" />
          <p className="no-transactions-container__wrapper__label">{t('PAYMENTS.NO_TRANSACTIONS_LABEL', { status: status ? status.toLowerCase() : '' })}</p>
        </div>
      </div>
    );
  }
}

PaymentHistoryNoTransactions.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default PaymentHistoryNoTransactions;



// WEBPACK FOOTER //
// ./src/app/main/payments/components/payment-history-no-transactions.js